import React, { useState, useEffect } from "react";
import { TextField, Button, FormControlLabel, Switch } from "@mui/material";
import { PMDialog } from "../../../utils/PMDialog";
import { useTranslation } from "react-i18next";

export const RemainingAmountSettingsDialog = ({
  open,
  onClose,
  onSave,
  initialSettings = null,
  saving = false,
}) => {
  const { t } = useTranslation();
  const [settings, setSettings] = useState({
    enabled: false,
    percentage: 10,
    base: "completed",
  });

  useEffect(() => {
    if (initialSettings) {
      setSettings({
        enabled: initialSettings.enabled || false,
        percentage: initialSettings.percentage ?? 10,
        base: "completed",
      });
    }
  }, [initialSettings, open]);

  const handleSave = () => {
    onSave(settings);
  };

  return (
    <PMDialog
      open={open}
      onClose={() => { if (!saving) onClose(); }}
      title={t("project.billing_plan.remaining_settings_title")}
      size="md"
      closeOnOutsideClick={false}
    >
      <div className="space-y-4">
        <p className="text-sm text-gray-600 mb-4">
          {t("project.billing_plan.retention_completed_explanation")}
        </p>

        {/* Enable/Disable */}
        <FormControlLabel
          control={
            <Switch
              disabled={saving}
              checked={settings.enabled}
              onChange={(e) => setSettings({ ...settings, enabled: e.target.checked })}
            />
          }
          label={t("project.billing_plan.retention_enable")}
        />

        {settings.enabled && (
          <>
            {/* Percentage */}
            <TextField
              disabled={saving}
              fullWidth
              label={t("project.billing_plan.retention_percentage")}
              type="number"
              value={settings.percentage}
              onChange={(e) => {
                const value = parseFloat(e.target.value) || 0;
                setSettings({ ...settings, percentage: Math.max(0, Math.min(100, value)) });
              }}
              inputProps={{ min: 0, max: 100, step: 0.1 }}
              helperText={t("project.billing_plan.retention_percentage_hint")}
            />

            {/* Preview */}
            <div className="bg-gray-50 p-4 rounded-lg">
              <p className="text-sm text-gray-600">
                {t("project.billing_plan.retention_helper_enabled", { pct: settings.percentage, base: t("project.billing_plan.retention_base_completed") })}
              </p>
            </div>
          </>
        )}

        {/* Actions */}
        <div className="flex justify-end space-x-3 mt-6 pt-4 border-t">
          <Button onClick={onClose} disabled={saving}>
            {t("common.cancel")}
          </Button>
          <Button
            onClick={handleSave}
            disabled={saving}
            variant="contained"
            className="bg-blue-600 hover:bg-blue-700"
          >
            {t(saving ? "common.saving" : "common.save")}
          </Button>
        </div>
      </div>
    </PMDialog>
  );
};

